import * as Types from '../types-api.generated';

import { MomentSearchItemFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentsSearchVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
}>;


export type ApiMomentsSearch = { momentsSearch: { items: Array<{ id: number, name: string, posterUrl: string | null, worldId: number, worldImageUrl: string | null, worldName: string, worldSlug: string }> } };



export const ApiMomentsSearchDocument = /*#__PURE__*/ `
    query MomentsSearch($searchTerm: String!) {
  momentsSearch: momentsSearchDb(query: $searchTerm, perPage: 3, page: 0) {
    items {
      ...MomentSearchItemFragment
    }
  }
}
    ${MomentSearchItemFragment}`;

export const useMomentsSearch = <
      TData = ApiMomentsSearch,
      TError = ClientError
    >(
      variables: ApiMomentsSearchVariables,
      options?: Omit<UseQueryOptions<ApiMomentsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentsSearch, TError, TData>(
      {
    queryKey: ['MomentsSearch', variables],
    queryFn: apiFetcher<ApiMomentsSearch, ApiMomentsSearchVariables>(ApiMomentsSearchDocument, variables),
    ...options
  }
    )};

useMomentsSearch.getKey = (variables: ApiMomentsSearchVariables) => ['MomentsSearch', variables];

export const useInfiniteMomentsSearch = <
      TData = InfiniteData<ApiMomentsSearch>,
      TError = ClientError
    >(
      variables: ApiMomentsSearchVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentsSearch, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentsSearch.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentsSearch, ApiMomentsSearchVariables>(ApiMomentsSearchDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentsSearch.getKey = (variables: ApiMomentsSearchVariables) => ['MomentsSearch.infinite', variables];


useMomentsSearch.fetcher = (variables: ApiMomentsSearchVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentsSearch, ApiMomentsSearchVariables>(ApiMomentsSearchDocument, variables, options);
